import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../interceptors";
import { baseUrl } from "../../config/config";

const TTL_MS = 60_000;

export const fetchBrandingCached = createAsyncThunk(
  "entityBranding/fetch",
  async ({ hostname } = {}, { getState, rejectWithValue }) => {
    const { logoColor, fetchedAt } =
      getState().entityBrandingSliceReducer || {};
    if (logoColor && Date.now() - fetchedAt < TTL_MS) {
      return { cached: true, data: logoColor };
    }
    try {
      const host =
        hostname || window.location.hostname?.split(".")[0] || "";
      const { data } = await axiosInstance.get(
        `${baseUrl}/common/base/newEntityRegistration/get-entity-logo-color?url=${host}`
      );
      return { cached: false, data };
    } catch (e) {
      return rejectWithValue(e?.message || "Failed to load branding");
    }
  }
);

const entityBrandingSlice = createSlice({
  name: "entityBranding",
  initialState: {
    logoColor: null,
    fetchedAt: 0,
    loading: false,
    error: null,
  },
  reducers: {
    clearBranding(state) {
      state.logoColor = null;
      state.fetchedAt = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrandingCached.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrandingCached.fulfilled, (state, { payload }) => {
        state.loading = false;
        if (!payload?.cached) {
          state.logoColor = payload?.data || null;
          state.fetchedAt = Date.now();
        }
      })
      .addCase(fetchBrandingCached.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload || "Failed to load branding";
      });
  },
});

export const { clearBranding } = entityBrandingSlice.actions;
export const selectBranding = (s) =>
  s.entityBrandingSliceReducer?.logoColor || null;
export const selectBrandingLoading = (s) =>
  !!s.entityBrandingSliceReducer?.loading;

export default entityBrandingSlice.reducer;
